import { Component, OnInit } from '@angular/core';
import { AuthQrantTypeEnum } from '../../enums/authQrantType.enum';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import { ToastsManager } from 'ng2-toastr';
import { AuthFromTypeEnum } from '../../enums/authFromTypeEnum.enum';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  public qrantTypeEnum = AuthQrantTypeEnum;
  public formTypeEnum = AuthFromTypeEnum;
  public formType = AuthFromTypeEnum.LOGIN;
  public checkGrantType = AuthQrantTypeEnum.LDAP;
  public tabIndex: number = 1;

  constructor(private route: ActivatedRoute, private toastr: ToastsManager) {}

  ngOnInit() {
    this.route.queryParams
      .filter(params => params.sessionExpired)
      .subscribe(params => {
        if (params) {
          this.toastr.warning('Zaloguj się ponownie', 'Sesja wygasła!');
        }
      });
  }

  isPasswordChanged(isPasswordChanged): void {
    if (isPasswordChanged) {
      this.formType = AuthFromTypeEnum.LOGIN;
    } else {
      this.formType = AuthFromTypeEnum.CHANGE_PASSWORD;
    }
  }

  changeFromType(): void {
    if (this.formType === AuthFromTypeEnum.LOGIN) {
      this.formType = AuthFromTypeEnum.CHANGE_PASSWORD;
    } else {
      this.formType = AuthFromTypeEnum.LOGIN;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/sign-in.component.ts